import * as slides from './slides'

export default slides
